import PasswordRecovery from './pages/Login/PasswordRecovery';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import Home from "./pages/Home";
import Login from "./pages/Login/Login";
import MyRecord from "./pages/MyRecord/MyRecord";
import { ConfigProvider, Spin, message } from 'antd';

import enUS from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';
import zh_TW from 'antd/lib/locale/zh_TW';
import MainLayout from "./layout/MainLayout";
import CampaignCreateForm from "./pages/Campaign/CampaignCreateForm";
import CampaignCreateIntro from "./pages/Campaign/CampaignCreateIntro";
import CampaignCreateSuccess from "./pages/Campaign/CampaignCreateSuccess";
import CampaignSelectType from "./pages/Campaign/CampaignSelectType";
import Donation from "./pages/Donation/Donation";
import DonationAmount from "./pages/Donation/DonationAmount";
import DonationHistory from "./pages/Donation/DonationHistory";
import DonationReceipt from "./pages/Donation/DonationReceipt";
import DonationResult from "./pages/Donation/DonationResult";
import DonationSelect from "./pages/Donation/DonationSelect";
import MyRecorDonationAmount from "./pages/MyRecord/MyRecorDonationAmount";
import MyRecordTotalRaised from "./pages/MyRecord/MyRecordTotalRaised";
import MyRecordDetail from "./pages/MyRecord/MyRecordDetail";
import RegisterSuccess from "./pages/Register/RegisterSuccess";
import NotFound from "./pages/Error/NotFound";
import ErrorPage from "./pages/Error/ErrorPage";
import RegisterFormA from "./pages/Register/RegisterFormA";
import RegisterFormB from "./pages/Register/RegisterFormB";
import './App.css';
import { MyColor } from "./config/myStyle";
import CampaignDetail from "./pages/Campaign/CampaignDetail";
import ContactUs from "./pages/ContactUs/ContactUs";
import { useEffect, useMemo } from "react";
import { userStore } from "./stores";
import RequireAuth from "./layout/RequireAuth";
import '../src/I18n';
import initStore from "./stores/initStore";

message.config({
  top: 110,
});

const App = observer(() => {


  useEffect(() => {
    initStore.init()
  }, [])

  const locale = useMemo(() => {
    switch (userStore.language) {
      case 'en': {
        return enUS
      }
      case 'zh-CN': {
        return zhCN
      }
      case 'zh-HK': {
        return zh_TW
      }
      default: {
        return enUS

      }
    }

  }, [userStore.language])


  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorError: '#ff3434',
          colorSuccess: '#19b15b',
          colorInfo: '#19b15b',
          colorWarning: 'orange',
          colorPrimary: MyColor.primary,
        },
      }}
    >
      {initStore.isInit ? <Spin fullscreen styles={{ mask: { backgroundColor: MyColor.bg } }} /> : (

        <Router>
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              {/* 创建活动流程 */}
              <Route path="/campaign/create" element={<RequireAuth><CampaignCreateIntro /></RequireAuth>} />
              <Route path="/campaign/:campaignId" element={<CampaignDetail />} />
              <Route path="/campaign/create/select-type" element={<RequireAuth><CampaignSelectType /></RequireAuth>} />
              <Route path="/campaign/create/form" element={<RequireAuth><CampaignCreateForm /></RequireAuth>} />
              <Route path="/campaign/create/success" element={<RequireAuth><CampaignCreateSuccess /></RequireAuth>} />


              {/* 捐款流程 */}
              <Route path="/donation" element={<Donation />} />
              <Route path="/donation-select" element={<DonationSelect />} />
              <Route path="/donation/:campaignId" element={<CampaignDetail />} />
              <Route path="/donation/:campaignId/amount" element={<DonationAmount />} />
              <Route path="/donation/:campaignId/amount/receipt/:donationId" element={<DonationReceipt />} />
              <Route path="/donation/:campaignId/amount/history/:donationId" element={<DonationHistory />} />
              <Route path="/donation/:campaignId/amount/result/" element={<DonationResult />} />
              {/* 记录流程 */}
              <Route path="/my-record" element={<RequireAuth><MyRecord /></RequireAuth>} />
              <Route path="/my-record/total-raised" element={<RequireAuth><MyRecordTotalRaised /></RequireAuth>} />
              <Route path="/my-record/donation-amount" element={<RequireAuth><MyRecorDonationAmount /></RequireAuth>} />
              <Route path="/my-record/:campaignId" element={<RequireAuth><MyRecordDetail /></RequireAuth>} />
              {/* 登录/注册 */}
              <Route path="/forgot-password" element={<PasswordRecovery />} />
              <Route path="/reset-password" element={<PasswordRecovery />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register/statement" element={<Navigate to="/register/form-a" replace />} />
              <Route path="/register/form-a" element={<RegisterFormA />} />
              <Route path="/register/form-b" element={<RegisterFormB />} />
              <Route path="/register/success" element={<RegisterSuccess />} />

              {/*联系我们*/}
              <Route path="/contact-us" element={<ContactUs />} />

              <Route path="/error" element={<ErrorPage />} />
              <Route path="*" element={<NotFound />} />

            </Route>


          </Routes>
        </Router>
      )}

    </ConfigProvider>

  );
});

export default App;


